import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment';

import { OrganicMatterReport } from '../models';

@Injectable({
  providedIn: 'root',
})
export class OrganicMatterService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/environmental-metric-service/organicmatterbalance';

  getOrganicMatterReport(
    cropYear: number,
    cropFieldIds: number[],
  ): Observable<OrganicMatterReport> {
    let params = new HttpParams();

    // Add each cropFieldId as a separate query parameter with the same name
    cropFieldIds.forEach((id) => {
      params = params.append('cropFieldIds', id.toString());
    });

    return this.http.get<OrganicMatterReport>(`${this.baseUrl}/${cropYear}/cropfields`, { params });
  }
}
